import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

const investorApi = {
  // Get investor profile
  getInvestorProfile: async (investorId) => {
    try {
      const response = await axios.get(`${API_URL}/api/investor/${investorId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching investor profile:', error);
      throw error.response?.data || error.message;
    }
  },

  // Update investor profile (supports FormData for file uploads)
  updateInvestorProfile: async (investorId, formData) => {
    try {
      const token = localStorage.getItem('token');
      // Don't set Content-Type manually — axios sets it automatically for
      // FormData with the correct multipart boundary.
      const response = await axios.put(`${API_URL}/api/investor/${investorId}`, formData, {
        headers: { 'x-auth-token': token }
      });
      return response.data;
    } catch (error) {
      console.error('Error updating investor profile:', error);
      throw error.response?.data || error.message;
    }
  },

  // Submit a site visit request
  submitSiteVisitRequest: async (data) => {
    try {
      // console.log('Submitting site visit request:', data);
      const response = await axios.post(
        `${API_URL}/api/investor/request`,
        {
          requestType: 'site-visit',
          ...data
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Site visit request error:', error.response?.data);
      throw error.response?.data || { success: false, errors: ['Failed to submit request'] };
    }
  },

  // Submit a land allotment application
  submitLandAllotmentRequest: async (data) => {
    try {
      // console.log('Submitting land allotment request:', data);
      const response = await axios.post(
        `${API_URL}/api/investor/request`,
        {
          requestType: 'land-allotment',
          ...data
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Land allotment request error:', error.response?.data);
      throw error.response?.data || { success: false, errors: ['Failed to submit application'] };
    }
  },

  // Submit a virtual meeting request
  submitVirtualMeetingRequest: async (data) => {
    try {
      // console.log('Submitting virtual meeting request:', data);
      const response = await axios.post(
        `${API_URL}/api/investor/request`,
        {
          requestType: 'virtual-meeting',
          ...data
        },
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Virtual meeting request error:', error.response?.data);
      throw error.response?.data || { success: false, errors: ['Failed to schedule meeting'] };
    }
  },

  // Get all investor requests (admin)
  getAllRequests: async (filters = {}) => {
    try {
      const token = localStorage.getItem('token');
      const params = new URLSearchParams(filters).toString();
      const response = await axios.get(
        `${API_URL}/api/investor/requests${params ? `?${params}` : ''}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Get investor requests error:', error.response?.data);
      throw error.response?.data || { success: false, message: 'Failed to fetch requests' };
    }
  },

  // Get single request by ID (admin)
  getRequestById: async (id) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(
        `${API_URL}/api/investor/requests/${id}`,
        {
          headers: {
            'Authorization': `Bearer ${token}`
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Get investor request error:', error.response?.data);
      throw error.response?.data || { success: false, message: 'Failed to fetch request' };
    }
  },

  // Update request status (admin)
  updateRequestStatus: async (id, statusData) => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.put(
        `${API_URL}/api/investor/requests/${id}`,
        statusData,
        {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        }
      );
      return response.data;
    } catch (error) {
      console.error('Update investor request error:', error.response?.data);
      throw error.response?.data || { success: false, message: 'Failed to update request' };
    }
  }
};

export default investorApi;
